module.exports = __webpack_public_path__ + "static/media/27OCHA2.18b81ca6.jpg";